export default [
  {
    path: '/policy/policyLibraryManagement/policyLink',
    name: 'PolicyLink',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/policy/policyLibraryManagement/policyLink/index.vue`),
    meta:{
      title: '政策链接管理',
      permission: ['management_background_policy_link']
    }
  },
  {
    path: '/policy/policyLibraryManagement/policyLibraryPermission',
    name: 'PolicyLibraryPermission',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/policy/policyLibraryManagement/policyLibraryPermission/index.vue`),
    meta:{
      title: '政策库权限管理',
      permission: ['management_background_auth']
    }
  },
  {
    path: '/policy/policyLibraryManagement/policyExpressMailSubscription',
    name: 'PolicyExpressMailSubscription',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/policy/policyLibraryManagement/policyExpressMailSubscription/index.vue`),
    meta:{
      title: '政策速递邮件订阅管理',
      permission: ['management_background_email']
    }
  },
  {
    path: '/policy/policyLibraryManagement/industryReport',
    name: 'IndustryReportManagement',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/policy/policyLibraryManagement/industryReport/index.vue`),
    meta:{
      title: '行业报告管理',
      permission: ['management_background_indsutry_report']
    }
  }
]
